import '@hotwired/turbo'
import '@rails/actiontext'
import '../controllers/public'
import { setupReactRails } from '../lib/react_rails'

setupReactRails()
